"use strict";

//////////// Data
///////////////////////////////

// Data for section News
const games = {
  game1: {
    mas: {
      players: [
        "Κατσίνας",
        "Γουλτίδης",
        "Τουρπεσλής",
        "Τύμης",
        "Παρπόρης Ν.",
        "Καραδήμος",
        "Καπασακαλής",
        "Βασιλειάδης",
      ],
      pts: [0, 19, 12, 19, 11, 9, 10, 16],
    },

    other: {
      players: [
        "Βασίλος",
        "Καρπουχτσής",
        "Γίδαρης",
        "Παυλίδης",
        "Μυλωνάς",
        "Μαρκάκης",
        "Γκέγκας",
        "Κάγκας Α.",
        "Κάγκας Θ.",
        "Γεωργουσάκης",
        "Σταφυλλίδης",
      ],
      pts: [0, 2, 4, 7, 7, 0, 3, 11, 21, 11, 3],
    },
  },

  game2: {
    mas: {
      players: [
        "Τουρπεσλής",
        "Βασιλειάδης",
        "Καλτσούνης",
        "Καπασακαλής",
        "Παρπόρης Α.",
        "Παρπόρης Ν.",
        "Καραδήμος Γ.",
        "Γουλτίδης",
        "Τύμης",
        "Βατιάνης",
      ],
      pts: [2, 3, 9, 7, 5, 0, 10, 8, 3, 16],
    },

    other: {
      players: [
        "Βαρλάμης",
        "Σιδεράς",
        "Κεφαλίδης",
        "Μιχαλόπουλος",
        "Τσορμπατζόγλου",
        "Αλεξίου",
        "Ράπτης",
        "Τρουμπουκίδης",
        "Ξυλάς",
        "Δαδάλας",
        "Ίτσκος",
        "Νεοφώτιστος",
      ],
      pts: [2, 10, 6, 0, 0, 5, 19, 0, 3, 0, 2, 2],
    },
  },

  game3: {
    mas: {
      players: [
        "Γουλτίδης",
        "Τουρπεσλής",
        "Καλτσούνης",
        "Καπασακαλής",
        "Τύμης",
        "Παρπόρης Α.",
        "Βατιάνης",
        "Καραδήμος Γ.",
        "Βασιλειάδης",
      ],
      pts: [12, 7, 21, 4, 10, 4, 5, 6, 6],
    },

    other: {
      players: [
        "Σιδηρόπουλος",
        "Σιούνης",
        "Μοσχότογλου Π.",
        "Μπατσιόλας",
        "Παπανικολάου",
        "Γερόπουλος",
        "Ιωαννίδης",
        "Βουδούρης",
        "Καραδήμος Ι.",
        "Σταμπουλής",
        "Φωτακίδης",
        "Μοσχότογλου Α.",
      ],
      pts: [17, 9, 5, 3, 6, 5, 0, 2, 0, 4, 3, 3],
    },
  },

  game4: {
    mas: {
      players: [
        "Τουρπεσλής",
        "Καπασακαλής",
        "Καλτσούνης",
        "Παρπόρης Α.",
        "Καραδήμος",
        "Γουλτίδης",
        "Τύμης",
        "Βατιάνης",
        "Βασιλειάδης",
      ],
      pts: [3, 4, 9, 12, 3, 7, 4, 3, 14],
    },

    other: {
      players: [
        "Λογγινίδης",
        "Σταμάτης",
        "Πατεράκης",
        "Βατακίδης",
        "Γκάτζογλου",
        "Χατζηαθανασίου",
        "Φουτσιτζής",
        "Παπαδόπουλος",
        "Στόϊλας",
        "Κωδωνάς",
        "Νατσιόπουλος",
        "Τσαρτσίδης",
      ],
      pts: [0, 7, 16, 0, 9, 6, 3, 7, 10, 4, 7, 0],
    },
  },
};

// Data for Standing
const team1 = {
  name: "ΑΙΣΧΥΛΟΣ",
  games: 7,
  wins: 6,
  losses: 1,
  points: 13,
};

const team2 = {
  name: "ΠΥΡΓΟΣ",
  games: 6,
  wins: 4,
  losses: 2,
  points: 10,
};

const team3 = {
  name: "ΕΘΝΙΚΟΣ",
  games: 6,
  wins: 2,
  losses: 4,
  points: 8,
};

const team4 = {
  name: "ΝΕΣΤΩΡ",
  games: 6,
  wins: 2,
  losses: 4,
  points: 8,
};

const team5 = {
  name: "ΚΕΡΑΥΝΟΣ",
  games: 7,
  wins: 6,
  losses: 1,
  points: 13,
};

const team6 = {
  name: "ΔΑΙΔΑΛΟΣ",
  games: 8,
  wins: 2,
  losses: 6,
  points: 10,
};

const team7 = {
  name: "ΜΕΓΑΣ ΑΛΕΞΑΝΔΡΟΣ",
  games: 6,
  wins: 3,
  losses: 3,
  points: 9,
};

const team8 = {
  name: "Ε.Ο.Σ.",
  games: 6,
  wins: 4,
  losses: 2,
  points: 10,
};

const team9 = {
  name: "ΜΑΥΡΑ ΠΡΟΒΑΤΑ",
  games: 6,
  wins: 0,
  losses: 6,
  points: 6,
};

const team10 = {
  name: "ΓΑΛΑΞΙΑΣ",
  games: 6,
  wins: 4,
  losses: 2,
  points: 10,
};

const team11 = {
  name: "ΛΑΓΚΑΔΑΣ",
  games: 7,
  wins: 7,
  losses: 0,
  points: 14,
};

const team12 = {
  name: "ΤΕΡΨΙΘΕΑΣ",
  games: 6,
  wins: 1,
  losses: 5,
  points: 7,
};

const team13 = {
  name: "ΛΗΤΗ",
  games: 6,
  wins: 3,
  losses: 3,
  points: 9,
};

const team14 = {
  name: "ΑΡΜΕΝΙΚΗ",
  games: 5,
  wins: 0,
  losses: 5,
  points: 5,
};

const teams = [
  team1,
  team2,
  team3,
  team4,
  team5,
  team6,
  team7,
  team8,
  team9,
  team10,
  team11,
  team12,
  team13,
  team14,
];

// Data for schedule
const teamSchedule = [
  {
    hw: "Away",
    dayString: "Παρασκευή",
    month: "Σεπ",
    day: "23",
    year: "22",
    time: "21:30",
    opponet: "ΛΗΤΗ",
    status: "W",
    score: "58 - 70",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Οκτ",
    day: "03",
    year: "22",
    time: "21:45",
    opponet: "ΑΡΜΕΝΙΚΗ",
    status: "W",
    score: "83 - 50",
  },

  {
    hw: "Away",
    dayString: "Σάββατο",
    month: "Οκτ",
    day: "08",
    year: "22",
    time: "21:00",
    opponet: "ΤΕΡΨΙΘΕΑ",
    status: "W",
    score: "53 - 55",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Οκτ",
    day: "17",
    year: "22",
    time: "21:45",
    opponet: "ΜΕΓΑΣ ΑΛΕΞΑΝΔΡΟΣ",
    status: "W",
    score: "83 - 58",
  },

  {
    hw: "Away",
    dayString: "Δευτέρα",
    month: "Οκτ",
    day: "24",
    year: "22",
    time: "21:00",
    opponet: "ΝΕΣΤΩΡ",
    status: "W",
    score: "53 - 64",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Νοε",
    day: "07",
    year: "22",
    time: "21:45",
    opponet: "ΕΘΝΙΚΟΣ",
    status: "W",
    score: "64 - 53",
  },

  {
    hw: "Away",
    dayString: "Κυριακή",
    month: "Νοε",
    day: "13",
    year: "22",
    time: "20:00",
    opponet: "Ε.Ο.Σ.",
    status: "L",
    score: "69 - 59",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Νοε",
    day: "21",
    year: "22",
    time: "21:45",
    opponet: "ΠΥΡΓΟΣ",
    status: "W",
    score: "75 - 57",
  },

  {
    hw: "Away",
    dayString: "Δευτέρα",
    month: "Νοε",
    day: "28",
    year: "22",
    time: "21:30",
    opponet: "ΜΑΥΡΑ ΠΡΟΒΑΤΑ",
    status: "W",
    score: "47 - 60",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Δεκ",
    day: "05",
    year: "22",
    time: "21:45",
    opponet: "ΔΑΙΔΑΛΟΣ",
    status: "W",
    score: "87 - 62",
  },

  {
    hw: "Away",
    dayString: "Παρασκευή",
    month: "Δεκ",
    day: "09",
    year: "22",
    time: "21:45",
    opponet: "ΚΕΡΑΥΝΟΣ",
    status: "L",
    score: "",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Δεκ",
    day: "19",
    year: "22",
    time: "21:45",
    opponet: "ΓΑΛΑΞΙΑΣ",
    status: "L",
    score: "",
  },

  {
    hw: "Away",
    dayString: "Παρασκευή",
    month: "Δεκ",
    day: "23",
    year: "22",
    time: "21:30",
    opponet: "ΛΑΓΚΑΔΑΣ",
    status: "L",
    score: "",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Ιαν",
    day: "20",
    year: "23",
    time: "21:45",
    opponet: "ΛΗΤΗ",
    status: "",
    score: "",
  },

  {
    hw: "Away",
    dayString: "Κυριακή",
    month: "Φεβ",
    day: "05",
    year: "23",
    time: "20:30",
    opponet: "ΑΡΜΕΝΙΚΗ",
    status: "",
    score: "",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Φεβ",
    day: "13",
    year: "23",
    time: "21:45",
    opponet: "ΤΕΡΨΙΘΕΑ",
    status: "",
    score: "",
  },

  {
    hw: "Away",
    dayString: "Παρασκευή",
    month: "Φεβ",
    day: "17",
    year: "23",
    time: "21:30",
    opponet: "ΜΕΓΑΣ ΑΛΕΞΑΝΔΡΟΣ",
    status: "",
    score: "",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Μαρ",
    day: "06",
    year: "23",
    time: "21:45",
    opponet: "ΝΕΣΤΩΡ",
    status: "",
    score: "",
  },

  {
    hw: "Away",
    dayString: "Δευτέρα",
    month: "Μαρ",
    day: "13",
    year: "23",
    time: "21:30",
    opponet: "ΕΘΝΙΚΟΣ",
    status: "",
    score: "",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Μαρ",
    day: "20",
    year: "23",
    time: "21:45",
    opponet: "ΣΤΑΥΡΟΥΠΟΛΗΣ",
    status: "",
    score: "",
  },

  {
    hw: "Away",
    dayString: "Παρασκευή",
    month: "Μαρ",
    day: "24",
    year: "23",
    time: "21:00",
    opponet: "ΠΥΡΓΟΣ",
    status: "",
    score: "",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Απρ",
    day: "03",
    year: "23",
    time: "21:45",
    opponet: "ΜΑΥΡΑ ΠΡΟΒΑΤΑ",
    status: "",
    score: "",
  },

  {
    hw: "Away",
    dayString: "Σάββατο",
    month: "Απρ",
    day: "08",
    year: "23",
    time: "21:00",
    opponet: "ΔΑΙΔΑΛΟΣ",
    status: "",
    score: "",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Απρ",
    day: "24",
    year: "23",
    time: "21:45",
    opponet: "ΚΕΡΑΥΝΟΣ",
    status: "",
    score: "",
  },

  {
    hw: "Away",
    dayString: "Παρασκευή",
    month: "Μαι",
    day: "05",
    year: "23",
    time: "20:45",
    opponet: "ΓΑΛΑΞΙΑΣ",
    status: "",
    score: "",
  },

  {
    hw: "Home",
    dayString: "Δευτέρα",
    month: "Μαι",
    day: "22",
    year: "23",
    time: "21:45",
    opponet: "ΛΑΓΚΑΔΑΣ",
    status: "",
    score: "",
  },
];

////// Elements
///////////////////////////////
const standingTable = document.querySelector(".table");
const scheduleContainer = document.querySelector(".sch__container");
const header = document.querySelector(".header");
const gamesContent = document.querySelectorAll(".games__content");

////// Function Implementations
///////////////////////////////

// Display All Players Poitns
export const bothTeams = function (gameNumber) {
  home(gameNumber);
  away(gameNumber);
};

///////////////////////////////////////
// Display Home Players Poitns
export const home = function (gameNumber) {
  games[`game${gameNumber}`].mas.players.forEach((name, i) => {
    const point = games[`game${gameNumber}`].mas.pts[i];
    const html = `
      <div class="points__row">
        <div class="points__row_name">${name}</div>
      </div>

      <div class="points__row">
        <div class="points__row_player-pts">${point}</div>
      </div>
    `;

    document
      .querySelector(`.games__points--${gameNumber}`)
      .insertAdjacentHTML("beforeend", html);
  });
};

///////////////////////////////////////
// Display Away Players Poitns
export const away = function (gameNumber) {
  games[`game${gameNumber}`].other.players.forEach((name, i) => {
    const point = games[`game${gameNumber}`].other.pts[i];
    const html = `
      <div class="points__row">
        <div class="points__row_name">${name}</div>
      </div>

      <div class="points__row">
        <div class="points__row_player-pts">${point}</div>
      </div>
    `;

    document
      .querySelector(`.games__points--${gameNumber}`)
      .insertAdjacentHTML("beforeend", html);
  });
};

///////////////////////////////////////
// Display Standing
export const standing = function () {
  const teamsStanding = teams.slice().sort((a, b) => b.points - a.points);

  teamsStanding.forEach((team, i) => {
    const html = `
      <div class="table__content table__content-name ${
        i + 1 === teamsStanding.length ? "no__border" : ""
      }">${team.name}</div>
      <div class="table__content ${
        i + 1 === teamsStanding.length ? "no__border" : ""
      }">${team.games}</div>
      <div class="table__content ${
        i + 1 === teamsStanding.length ? "no__border" : ""
      }">${team.wins}</div>
      <div class="table__content ${
        i + 1 === teamsStanding.length ? "no__border" : ""
      }">${team.losses}</div>
      <div class="table__content ${
        i + 1 === teamsStanding.length ? "no__border" : ""
      }">${team.points}</div>
    `;

    standingTable.insertAdjacentHTML("beforeend", html);
  });
};

///////////////////////////////////////
// Display Schedule
export const schedule = function (homeAway = "all") {
  const gamesShedule = teamSchedule.filter((game) => {
    if (game.hw === homeAway.charAt(0).toUpperCase() + homeAway.slice(1)) {
      return game;
    }

    if (homeAway === "all") return game;
  });

  let gameStatus;

  gamesShedule.forEach((game) => {
    if (game.status === "W") {
      gameStatus = "sch__result-win";
    } else if (game.status === "L") {
      gameStatus = "sch__result-lose";
    } else {
      gameStatus = "";
    }

    const html = `
        <div class="sch__container-row ${
          !gameStatus ? "next-game-schedule" : ""
        }">
          <div class="sch__gha home ${game.hw === "Home" ? "home" : "away"}">${
      game.hw
    }</div>
          <ul class="sch__date">
            <li class="sch__date-day">${game.dayString}</li>
            <li class="sch__date-md">${game.day} ${game.month} ${game.year}</li>
            <li class="sch__date-time">${game.time}</li>
          </ul>
          <div class="sch__opponent">${game.opponet}</div>
          <div class="sch__result">
            <div class="${gameStatus}">${game.status}</div>
            <div class="sch__score">${game.score}</div>
          </div>
        </div>
    `;

    scheduleContainer.insertAdjacentHTML("beforeend", html);
  });
};

///////////////////////////////////////
// Nav fade animation
export const fadeNavigationButtons = function (e) {
  if (e.target.classList.contains("nav__link")) {
    const link = e.target;
    const siblingLinks = link.closest(".nav").querySelectorAll(".nav__link");
    const logo = link.closest(".header").querySelector("#header_logo");

    siblingLinks.forEach((el, i) => {
      if (el !== link) {
        el.style.opacity = this;
      }
    });

    logo.style.opacity = this;
  }
};

///////////////////////////////////////
// Carousel display
export const carouselOnNext = function (e) {
  const carouserInner = e.target
    .closest(".carousel")
    .querySelector(".carousel-inner");

  const carouselItems = carouserInner.querySelectorAll(".carousel-item");

  const gameNumber = getActiveGame(carouselItems, "next");

  gamesContent.forEach((game) =>
    game.classList.remove("games__content--active")
  );

  activeGame(gameNumber);

  bothTeams(gameNumber);
};

export const carouselOnPrev = function (e) {
  const carouserInner = e.target
    .closest(".carousel")
    .querySelector(".carousel-inner");

  const carouselItems = carouserInner.querySelectorAll(".carousel-item");

  const gameNumber = getActiveGame(carouselItems, "prev");

  gamesContent.forEach((game) =>
    game.classList.remove("games__content--active")
  );

  activeGame(gameNumber);

  bothTeams(gameNumber);
};

export const activeGame = function (gameNumber = 1) {
  document
    .querySelector(`.games__content--${gameNumber}`)
    .classList.add("games__content--active");
};

const getActiveGame = function (items, move) {
  let gameNumber = 0;

  items.forEach((el) => {
    if (el.classList.contains("active")) {
      if (move === "prev") {
        if (+el.dataset.tab === 1) {
          gameNumber = 4;
        } else {
          gameNumber = +el.dataset.tab - 1;
        }
      } else {
        if (+el.dataset.tab === 4) {
          gameNumber = 1;
        } else {
          gameNumber = +el.dataset.tab + 1;
        }
      }
    }
  });

  return gameNumber;
};

///////////////////////////////////////
// Sticky navigation
export const stickyNav = function (entries) {
  const [entry] = entries;

  if (!entry.isIntersecting) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
};
